import React from "react";
import { ArrowRight } from "lucide-react";
import { steps } from "./data";

/**
 * HowItWorksSection — "De la inquietud al diagnóstico, en cuatro pasos".
 */
export function HowItWorksSection() {
  return (
    <section className="border-b border-gray-200 bg-white">
      <div className="container-prose py-20">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">Cómo funciona</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-3">
            De la inquietud al diagnóstico, en cuatro pasos.
          </h2>
          <p className="text-gray-600">
            Empieza gratis, sin tarjeta. Escala a Diagnóstico o Kit Documental cuando el caso lo amerite.
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-6">
          {steps.map(({ n, icon: Icon, title, body }, idx) => (
            <div
              key={n}
              className="relative p-6 bg-white border border-gray-200 rounded-sm hover:border-brand-burgundy transition-colors group"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="font-serif text-4xl text-brand-burgundy font-semibold leading-none">{n}</div>
                <Icon className="h-5 w-5 text-brand-coral" aria-hidden="true" />
              </div>
              <h3 className="font-serif text-lg text-gray-900 mb-2">{title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
              {idx < steps.length - 1 && (
                <ArrowRight
                  aria-hidden="true"
                  className="hidden md:block absolute -right-4 top-9 h-4 w-4 text-gray-300"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
